import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const WecNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="wec" />;
};
